import { render } from "./AreasList.vue?vue&type=template&id=dfaf17f6&scoped=true"
import script from "./AreasList.vue?vue&type=script&lang=js"
export * from "./AreasList.vue?vue&type=script&lang=js"

import "./AreasList.vue?vue&type=style&index=0&id=dfaf17f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfaf17f6"]])

export default __exports__